export function Logo({ subtitle = "Free Tools" }: { subtitle?: string }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
      <img src="/brand/logos/railassurance-lockup-on-dark.svg" alt="RailAssurance" style={{ height: 22 }} />
      {subtitle && (
        <span
          style={{
            fontFamily: "'Barlow', sans-serif",
            fontSize: "9.5px",
            fontWeight: 600,
            letterSpacing: "0.14em",
            textTransform: "uppercase" as const,
            color: "#7A8599",
            borderLeft: "1px solid rgba(245,248,250,0.10)",
            paddingLeft: 12,
          }}
        >
          {subtitle}
        </span>
      )}
    </div>
  );
}
